export default "__VITE_ASSET__Ja6yMKGX__"